<div class="cf_annulus" [ngClass]="sizeRotationAndStrokeClasses">
	<span class="{{ iconClass }}" [ngClass]="positionClass"></span>
</div>
